/**
 * Unicode Character block names
 *
 * List of blocks https://unicode.org/reports/tr18/#RL2.7
 * Usage in regex documentation https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Unicode_Property_Escapes
 */
export abstract class UnicodeBlocks {
  public static readonly DIACRITIC_BLOCK = 'Diacritic'; // Combining Diacritical Marks block https://www.compart.com/en/unicode/block/U+0300
}
